// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  ShippingCarrier,
  getShippingCarrierLabel,
} from '@/constants/shipping-carrier';

interface AuditCarrierValue {
  carrier: ShippingCarrier | null;
  name?: string | null;
}

/** Returns the carrier's display name for an audit value. */
export function toAuditCarrierName(
  value: AuditCarrierValue | null | undefined
): string | null {
  if (value?.name) {
    return value.name;
  }

  if (value?.carrier) {
    return getShippingCarrierLabel(value.carrier);
  }

  return null;
}
